import { IDocumentSearchCriteria } from '../../../../customProxy/retailExtension/DataServiceEntities.g';
import { PropertyType } from '../propertyTypeEnum';
import { ICartAndActions } from '../types/buybox';

const lookForToRequestData = {
    [PropertyType.cpid]: 'CPID',
    [PropertyType.lincNumber]: 'LincNumber',
    [PropertyType.rollNumber]: 'RollNumber',
    [PropertyType.titleNumber]: 'TitleNumber'
};

const othersToRequestData = {
    [PropertyType.address]: 'Address',
    [PropertyType.legalDescription]: 'LegalDescription',
    [PropertyType.legalDescriptionCondo]: 'LegalDescriptionCondo'
};

const getAddressRequestData = (cartAndAction: ICartAndActions): IDocumentSearchCriteria => {
    const { suite, addressNumber, streetName, quadrant, streetType } = cartAndAction;
    const { propertyType, lookFor, plan, unit, ldcPlan, block, lot } = cartAndAction;
    const legalDescriptionCondo = {
        Plan: ldcPlan.value?.trim(),
        Unit: unit.value?.trim()
    };
    const legalDescription = {
        Plan: plan.value?.trim(),
        Block: block.value?.trim(),
        Lot: lot.value?.trim()
    };
    const address = {
        StreetName: streetName.value?.trim(),
        StreetType: streetType.value?.trim(),
        Quadrant: quadrant.value?.trim(),
        Suite: suite.value?.trim(),
        Number: addressNumber.value?.trim()
    };
    const possibles = {
        address,
        legalDescription,
        legalDescriptionCondo
    };
    const requestData = {
        Id: 0,
        QueryType: propertyType,
        Address: [],
        LegalDescription: [],
        LegalDescriptionCondo: [],
        CPID: [],
        TitleNumber: [],
        LincNumber: [],
        RollNumber: [],
        ATSNos: [],
        BlockProfileNumbers: [],
        Communities: [],
        Quadrants: []
    };
    if (lookForToRequestData[propertyType]) {
        requestData[lookForToRequestData[propertyType]].push(lookFor.value?.trim());
    } else {
        requestData[othersToRequestData[propertyType]].push(possibles[PropertyType[propertyType]]);
    }
    return requestData;
};

export default getAddressRequestData;
